// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.create-form{margin:2rem;padding:2rem;border:0.1rem solid silver}\n", ""]);
// Exports
module.exports = exports;
